export default __webpack_public_path__ + "static/media/g5.69684482.jpg";